<template>
  <!-- 引き出し -->
  <a-drawer :title="$t('disp.editDictItem')" :width="screenWidth" @close="onClose" :visible="visible">
    <!-- 引き出し内容のborder -->
    <div
      :style="{
        padding: '15px 0',
        background: '#fff',
      }"
    >
      <div class="table-page-search-wrapper">
        <a-form
          layout="inline"
          :form="form"
          @keyup.enter.native="searchQuery(false, false)"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-row :gutter="24">
            <a-col :sm="24" :md="8">
              <a-form-item :label="$t('disp.itemText')">
                <a-input
                  :placeholder="$t('disp.ph.match', [$t('disp.itemText')])"
                  v-model="queryParam.itemText"
                ></a-input>
              </a-form-item>
            </a-col>
            <a-col :sm="24" :md="4">
              <a-form-item :label="$t('disp.status')">
                <j-dict-select-tag
                  v-model="queryParam.status"
                  :placeholder="$t('disp.ph.select.default')"
                  dictCode="valid_status"
                  :require="false"
                />
              </a-form-item>
            </a-col>
            <a-col :sm="24" :md="12" class="width-fit-content">
              <a-button type="primary" @click="searchQuery(false, false)" icon="search">{{
                $t('disp.btn.search')
              }}</a-button>

              <a-button @click="searchReset" icon="stop">{{ $t('disp.btn.reset') }}</a-button>

              <a-divider type="vertical"></a-divider>

              <a-button style="margin-bottom: 10px" type="primary" @click="handleAdd" icon="plus">{{
                $t('disp.btn.add')
              }}</a-button>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <div>
        <a-table
          ref="table"
          class="action"
          tableLayout="auto"
          :columns="columns"
          :dataSource="dataSource"
          :pagination="ipagination"
          :loading="loading"
          @change="handleTableChange"
        >
          <div slot="status" slot-scope="text, record">
            <a-tag color="green" v-if="record.status == 1">{{ $getDict('valid_status', record.status) }}</a-tag>
            <a-tag v-else>{{ $getDict('valid_status', record.status) }}</a-tag>
          </div>
          <span slot="action" slot-scope="text, record">
            <a @click="handleEdit(record)">{{ $t('disp.btn.edit') }}</a>
            <a-divider type="vertical" />
            <a-popconfirm :title="$t('msg.confirm.delete')" @confirm="() => handleDelete(record.id)">
              <a>{{ $t('disp.btn.delete') }}</a>
            </a-popconfirm>
          </span>
        </a-table>
      </div>
      <!-- 汎用情報 -->
      <dict-item-modal ref="modalForm" @ok="modalFormOk"></dict-item-modal>
    </div>
  </a-drawer>
</template>

<script>
import pick from 'lodash/pick'
import { filterObj } from '@/utils/util'
import DictItemModal from './modules/DictItemModal'
import { tableMixin } from '@/mixins/tableMixin'

export default {
  name: 'DictItemList',
  mixins: [tableMixin],
  components: { DictItemModal },
  data() {
    return {
      columns: [
        {
          title: this.$t('disp.itemText'),
          dataIndex: 'itemText',
        },
        {
          title: this.$t('disp.itemText1'),
          dataIndex: 'itemText1',
        },
        {
          title: this.$t('disp.itemText2'),
          dataIndex: 'itemText2',
        },
        {
          title: this.$t('disp.itemValue'),
          align: 'left',
          dataIndex: 'itemValue',
        },
        {
          title: '排序',
          align: 'center',
          width: 70,
          dataIndex: 'sortOrder',
        },
        {
          title: this.$t('disp.status'),
          align: 'center',
          width: 70,
          scopedSlots: { customRender: 'status' },
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          scopedSlots: { customRender: 'action' },
        },
      ],
      queryParam: {
        dictId: '',
        dictName: '',
        itemText: '',
        delFlag: '1',
        status: [],
      },
      visible: false,
      screenWidth: 1000,
      model: {},
      dictId: '',
      status: 1,
      labelCol: {
        xs: { span: 6 },
        sm: { span: 6 },
      },
      wrapperCol: {
        xs: { span: 18 },
        sm: { span: 18 },
      },
      form: this.$form.createForm(this),
      url: {
        list: '/blaze-sys/k00/k0006/DictItemManage/list',
        delete: '/blaze-sys/k00/k0006/DictItemManage/delete',
        deleteBatch: '/blaze-sys/k00/k0006/DictItemManage/deleteBatch',
      },
    }
  },
  created() {
    // 画面初期化するとき、スクリーンのサイズに応じて引き出しの幅を設定する
    this.resetScreenSize()
  },
  methods: {
    add(dictId) {
      this.dictId = dictId
      this.edit({})
    },
    edit(record) {
      if (record.id) {
        this.dictId = record.id
      }
      this.queryParam = {}
      this.form.resetFields()
      this.model = Object.assign({}, record)
      this.model.dictId = this.dictId
      this.model.status = this.status
      this.visible = true
      this.$nextTick(() => {
        this.form.setFieldsValue(pick(this.model, 'itemText', 'itemValue'))
      })
      // 他のモジュールは該当するモジュールの時、このファンクションを使用して汎用情報を取得
      this.searchQuery(true, true)
    },

    getQueryParams() {
      var param = Object.assign({}, this.queryParam)
      param.dictId = this.dictId
      //param.field = this.getQueryField()
      param.pageNo = this.ipagination.current
      param.pageSize = this.ipagination.pageSize
      return filterObj(param)
    },

    // 汎用情報を追加
    handleAdd() {
      this.$refs.modalForm.add(this.dictId)
    },
    showDrawer() {
      this.visible = true
    },
    onClose() {
      this.visible = false
      this.form.resetFields()
      this.dataSource = []
    },
    // 引き出しの幅はスクリーンのサイズに応じて調整する
    resetScreenSize() {
      let screenWidth = document.body.clientWidth
      if (screenWidth < 1000) {
        this.screenWidth = screenWidth
      } else {
        this.screenWidth = 1000
      }
    },
  },
}
</script>
<style scoped></style>
